<template>
    <div class="search-teams-form card">
      <el-form
        :rules="rules"
        :model="formData"
        label-position="top"
        ref="form"
        @submit.native.prevent=""
      >
        <div class="search-teams-form__default">
          <div class="row">
            <div class="col col-xs-12 col-md-6">
              <el-form-item
                label="Activity"
                prop="activityId"
                :error="errors.activityId"
              >
                <el-select
                  class="wide"
                  v-model="formData.activityId"
                  placeholder="Choose from the list"                  
                >
                  <el-option label="Any" :value="''" />
                  <el-option
                    v-for="type in descriptions.activityType"
                    :key="type.value"
                    :label="type.description"
                    :value="type.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="col col-xs-12 col-md-6">
              <el-form-item
                label="Name contains"
                prop="name"
                :error="errors.name"
              >
                <el-input v-model="formData.name" />
              </el-form-item>
            </div>
          </div>
        </div>
  

        <div class="row">
            <div class="col col-xs-12">
                <el-form-item
                label="Description contains"
                prop="description"
                :error="errors.description"
                >
                <el-input v-model="formData.description" />
                </el-form-item>
            </div>
        </div>

        <div class="row">
            <div class="col col-xs-12 col-md-3">
                <el-form-item
                label="Within"
                prop="distance"
                :error="errors.distance"
                >
                <el-input v-model="formData.distance" />
                </el-form-item>
            </div>
            <div class="col col-xs-12 col-md-2">
              <el-form-item
                label="units"
                prop="distanceUnit"
                :error="errors.distanceUnit"
              >
                <el-select
                  class="wide"
                  v-model="formData.distanceUnit"
                  placeholder="Choose from the list"
                >
                  <el-option
                    v-for="unit in distanceUnits"
                    :key="unit"
                    :label="unit"
                    :value="unit"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="col col-xs-12 col-md-7">
                <el-form-item
                label="from"
                prop="location"
                :error="errors.location"
                >
                <el-input v-model="formData.location" />
                </el-form-item>
            </div>
        </div>
  
        <div class="search-teams-form__bottom">
  
          <div class="search-teams-form__buttons">
            <el-button
              type="primary"
              @click="resetForm"
              native-type="reset"
              :disabled="isButtonDisabled('search-teams')"
            >
              Reset search
            </el-button>
            <el-button
              type="primary"
              @click="validateForm"
              native-type="submit"
              :disabled="isButtonDisabled('search-teams')"
            >
              Search
            </el-button>
          </div>
        </div>
      </el-form>
    </div>
  </template>
  
  <script>
  import {
    searchTeams,
  } from '@/api/team.js';

  import { removeTimezoneOffset, parseErrorsByFields } from '@/utils/index.js';
  import { showMessage } from '@/utils/messages.js';
  import { disableButton } from '@/mixins/disableButton.js';
  
  export default {
    name: 'SearchTeamsForm',
    props: {
      skip: {
        type: Number,
        required: false,
      },
      limit: {
        type: Number,
        required: false,
      },
    },
    mixins: [disableButton],
    data() {
      return {
        searchType: 0,
        distanceUnits: ['km', 'mi', 'nm'],
        formData: {
          activityId: null,
          status: null,
          activityTeamTypeId: null,
          name: null,
          startDateFrom: null,
          startDateTo: null,
          endDateFrom: null,
          endDateTo: null,
          location: null,
          teamLevelTypeFrom: null,
          teamLevelTypeTo: null,
          description: null,
        },
        errors: {
          activityId: '',
          status: '',
          activityTeamTypeId: '',
          name: '',
          startDateFrom: '',
          startDateTo: '',
          endDateFrom: '',
          endDateTo: '',
          location: '',
          teamLevelTypeFrom: '',
          teamLevelTypeTo: '',
          description: '',
        },
        rules: {
          activityId: [{ required: false, trigger: 'blur', message: '' }],
          name: [{ required: false, trigger: 'blur', message: '' }],
          distanceUnit: [{ required: false, trigger: 'blur', message: '' }],
          distance: [{ required: false, trigger: 'blur', message: '' }],
          location: [{ required: false, trigger: 'blur', message: '' }],
          description: [{ required: false, trigger: 'blur', message: '' }],
        },

      };
    },
    computed: {
      searchFormData() {
        const { skip, limit, searchType } = this;
        const {
          activityId,
          name,
          location,
          description,
          distance,
          distanceUnit,
        } = this.formData;
  
        const data = {
          skip,
          limit,
          filterModel: {
            activityId,
            name,
            location,
            description,
            distance,
            distanceUnit,
          },
        };
  
        return data;
      },
      descriptions() {
        return this.$store.state.descriptions;
      },
      isActivityChosen() {
        const { activityId } = this.formData;
  
        return activityId !== null;
      },
    },
    methods: {
      removeTimezoneOffset,
      parseErrorsByFields,
      showMessage,
      async fetchTeams() {
        this.disableButton('search-teams');
        const { searchFormData } = this;
        const { data, success, errors } = await searchTeams(searchFormData);
        this.enableButton('search-teams');
  
        if (success) {
          this.$emit('receive-data', data);
        } else if (errors) {
          this.errors = { ...this.errors, ...this.parseErrorsByFields(errors) };
        }
      },


      validateForm() {
        this.fetchTeams();
      },
      toggleSearchType() {
        this.searchType = this.searchType === 0 ? 1 : 0;
      },

      resetForm() {
        for (const key in this.formData) {
          this.formData[key] = key === 'status' ? 2 : null;
        }
        this.$emit('reset-data');
      },
    },
    async created() {
    
    },
    watch: {
      skip() {
        this.fetchTeams();
      },
      limit() {
        this.fetchTeams();
      },
    },
  };
  </script>
  
  <style lang="scss">
  @import '~@/styles/shared/_globals.scss';
  
  .search-teams-form {
    &__default {
    }
    &__extended {
    }
    &__bottom {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
    }
    &__toggler {
    }
    &__buttons {
    }
    &__subtitle {
      margin-top: 0;
    }
  }
  </style>
  